module.exports = __webpack_public_path__ + "static/media/btc_share.1465971b.jpg";